export const userProfileTextRegex = /^[\p{L}\p{M}\p{Nd} .,'\u2019\-()]*$/u;

export const userPhoneTextRegex = /^[+\p{Nd} ()-]*$/u;
